import type { Article } from '@flocasts/flosports30-types/dist/entity'
import type { FloResponse } from '@flocasts/flosports30-types/dist/flo-rest-api/response'
import { ArticleDataService } from '../article-data.service'
import { Observable } from 'rxjs'
import { Injectable } from '@angular/core'
import { ActivatedRouteSnapshot, Resolve } from '@angular/router'
import { ARTICLE_SLUG_ROUTE_PARAM } from '../articles.utility'

type RouteParamData = Pick<ActivatedRouteSnapshot, 'paramMap' | 'url' | 'queryParamMap'>

@Injectable({
  providedIn: 'root'
})
export class ArticleResolver implements Resolve<FloResponse<Article, {}>> {
  constructor(private readonly articleDataService: ArticleDataService) {}

  public resolve(route: RouteParamData): Observable<FloResponse<Article, {}>> {
    const showDraft =
      route.queryParamMap.get('future') === '1' && (route.queryParamMap.get('status')?.indexOf('0') ?? -1) >= 0

    const param = route.paramMap.get(ARTICLE_SLUG_ROUTE_PARAM) || ''
    const id = param.split('-')[0]
    return this.articleDataService.getArticle(id, showDraft)
  }
}
